import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { CampaignState } from 'src/app/_shared/state/campaign.state';
import { AppState } from 'src/app/app.state';
import constant from 'src/constant.json';

@Component({
  selector: 'app-campaign-automation-dialog',
  templateUrl: './campaign-automation-dialog.component.html',
  styleUrls: ['./campaign-automation-dialog.component.scss'],
})
export class CampaignAutomationDialogComponent implements OnInit {
  frequencyList: Array<string> = ['monthly', 'yearly'];
  shouldAutomateCampaign: boolean = false;
  onDestroyNotifier$ = new Subject();
  campList = [constant.CAMPAIGN_TYPE.cashOutRefinanceCamp, constant.CAMPAIGN_TYPE.valueUpdateCamp, constant.CAMPAIGN_TYPE.marketValueCamp];
  constructor(public dialogRef: MatDialogRef<CampaignAutomationDialogComponent>, public appState: AppState, public campaignState: CampaignState,
  ) { }

  ngOnInit(): void {
    if (this.appState?.appCompanyAliasValue == 'valuetest') {
      this.frequencyList = ['Monthly', 'Quarterly', 'Half Yearly', 'Yearly'];
    }

    this.campaignState.selectedCampType$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((campType) => {
      if (this.campList.includes(campType)) {
        this.frequencyList = ['Monthly', 'Quarterly', 'Yearly'];
      }
    });
  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();

  }
  toggleChange(event: MatSlideToggleChange) {
    this.shouldAutomateCampaign = event.checked;
  }
}
